<app-loading *ngIf="!contentReady"></app-loading>

<div class="container mb-4" *ngIf="contentReady">
  <div class="row additem-content">
    <h2 class="additemhead">{{ 'New client' | translate }}</h2>

    <form class="form" [formGroup]="data" (ngSubmit)="onSubmit()">
      <div class="d-flex flex-column flex-sm-row justify-content-center">
        <div class="col-12 form-container">
          <!-- Name -->
          <div class="form-group">
            <input class="input" type="text" formControlName="name" placeholder="{{ 'Name' | translate }}" />
          </div>

        @if(!isUpdatePage){
          <div class="form-group">
            <input class="input" type="text" formControlName="mobile" placeholder="{{ 'Phone Number' | translate }}" />
          </div>
        }
    
        <!-- مثال على تواريخ -->
          <div class="form-group">
            <input class="input" type="text" placeholder="تاريخ التسجيل" (focus)="type='date'"
              (blur)="!data.get('register_date')?.value && (type='text')" [attr.type]="type"
              formControlName="register_date" />
          </div>
      <div class="from-group" style="margin-top: 15px;">
          <h2 class="additemhead">
            تكلفة الداتا فلو
          </h2>
        </div>

      
        <div class="form-group">
          <input class="input" type="number" formControlName="dataflow_egp" placeholder="بالجنيه المصري" />
        </div>
        <div class="form-group">
          <input class="input" type="number" formControlName="dataflow_sar" placeholder="بالريال السعودي" />
        </div>
      
                <div class="form-group">
            <select class="input" formControlName="dataflow_pay_method">
              <option value="">-- اختر طريقة الدفع --</option>
              <option value="محفظة الالكترونية"> محفظة الالكترونية</option>
              <option value="انتساباي"> انتساباي</option>
              <option value="كاش"> كاش</option>
               <option value="تحويل بنكي"> تحويل بنكي</option>
            </select>
          </div>
        <div class="from-group" style="margin-top: 15px;">
          <h2 class="additemhead">
            رسوم الجامعة
          </h2>
        </div>

        <!-- University Fees -->
        <div class="form-group">
          <input class="input" type="number" formControlName="university_fees_egp" placeholder="بالجنيه المصري" />
        </div>
        <div class="form-group">
          <input class="input" type="number" formControlName="university_fees_sar" placeholder="بالريال السعودي" />
        </div>

                 <div class="form-group">
            <select class="input" formControlName="university_fees_pay_method">
              <option value="">-- اختر طريقة الدفع --</option>
              <option value="محفظة الالكترونية"> محفظة الالكترونية</option>
              <option value="انتساباي"> انتساباي</option>
              <option value="كاش"> كاش</option>
               <option value="تحويل بنكي"> تحويل بنكي</option>
            </select>
          </div>
          <div class="from-group" style="margin-top: 15px;">
            <h2 class="additemhead">
              تكلفة حجز رقم أحقية
            </h2>
          </div>
           <div class="form-group">
          <input class="input" type="number" formControlName="eligibility_res_egp" placeholder="بالجنيه المصري" />
        </div>
        <div class="form-group">
          <input class="input" type="number" formControlName="eligibility_res_sar" placeholder="بالريال السعودي" />
        </div>
  
                  <div class="form-group">
            <select class="input" formControlName="eligibility_res_pay_method">
              <option value="">-- اختر طريقة الدفع --</option>
              <option value="محفظة الالكترونية"> محفظة الالكترونية</option>
              <option value="انتساباي"> انتساباي</option>
              <option value="كاش"> كاش</option>
               <option value="تحويل بنكي"> تحويل بنكي</option>
            </select>
          </div>

   
          <div class="from-group" style="margin-top: 15px;">
            <h2 class="additemhead">
                 حساب ممارس بلس</h2>
          </div>
        <div class="form-group">
          <input class="input" type="text" formControlName="email" placeholder="{{ 'Email' | translate }}" />
        </div>

        <!-- Mobile -->
        <div class="form-group">
          <input class="input" type="text" formControlName="password" placeholder="{{ 'Password' | translate }}" />
        </div>
          <div class="from-group" style="margin-top: 15px;">
            <h2 class="additemhead">
              تكلفة التسجيل المهني
            </h2>
          </div>
          <div class="form-group">
            <input class="input" type="number" formControlName="first_class_egp" placeholder="بالجنيه المصري " />
          </div>
          <div class="form-group">
            <input class="input" type="number" formControlName="first_class_sar" placeholder="بالريال السعودي" />
          </div>
   
                          <div class="form-group">
            <select class="input" formControlName="first_class_pay_method">
              <option value="">-- اختر طريقة الدفع --</option>
              <option value="محفظة الالكترونية"> محفظة الالكترونية</option>
              <option value="انتساباي"> انتساباي</option>
              <option value="كاش"> كاش</option>
               <option value="تحويل بنكي"> تحويل بنكي</option>
            </select>
          </div>
       <div class="from-group" style="margin-top: 15px;">
            <h2 class="additemhead">
              تكلفة اصدار التصنيف النهائي</h2>
          </div>
          <div class="form-group">
            <input class="input" type="number" formControlName="final_reg_egp" placeholder="بالجنيه المصري" />
          </div>
          <div class="form-group">
            <input class="input" type="number" formControlName="final_reg_sar" placeholder="بالريال السعودي" />
          </div>

          <div class="form-group">
            <select class="input" formControlName="final_reg_pay_method">
              <option value="">-- اختر طريقة الدفع --</option>
              <option value="محفظة الالكترونية"> محفظة الالكترونية</option>
              <option value="انتساباي"> انتساباي</option>
              <option value="كاش"> كاش</option>
               <option value="تحويل بنكي"> تحويل بنكي</option>
            </select>
          </div>
          
  
        <!-- Notes -->
        <div class="form-group">
          <textarea class="input" formControlName="notes" placeholder="{{ 'note' | translate }}"></textarea>
        </div>
        <div class="form-group">
          <button type="submit" class="fromsave accont" [disabled]="data.invalid">
            @if(isUpdatePage){
            {{ 'Edit' | translate }}

            }
            @else{
            {{ 'Create Client' | translate }}

            }
          </button>
        </div>

      </div>
  </div>
  </form>
</div>
</div>